


















































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { round } from '@/utils/math'
import { ReceivedValues } from '@/store/ble/types'
import { VitalsignPayload } from '@/api/vitalsign/types'

const VITAL_DELAY = 60

@Component({
  components: {
    NoticeModal: () => import('@/components/common/modals/NoticeModal.vue')
  },
  filters: {
    formatDate(date: string) {
      return dayjs(date).format('MM月DD日 HH:mm')
    },
    formatVitalsignValue(value: number | null, type: string) {
      if (type === 'glucose') {
        if (value && value >= 601) return 'High'
        if (value && value <= 19) return 'Low'
      }
      if (type === 'temperature' && value) {
        return value.toFixed(1)
      }
      return value ? value : '-'
    }
  }
})
export default class Home extends Vue {
  $store!: ExStore
  round = round
  noticeMessage = ''
  showNoticeModal = false
  pending = false
  vital: VitalsignPayload | null = null
  timerId: number | undefined

  getReceivedValue(propName: keyof ReceivedValues) {
    if (this.isRelative && this.vital) {
      return this.getFetchedValue(propName)
    }
    const value = this.$store.getters['ble/receivedValues'][propName]
    return value ? round(value, 1) : value
  }

  getFetchedValue(propName: keyof ReceivedValues) {
    const vitalNames = {
      systolicPressure: 'sbp',
      diastolicPressure: 'dbp'
    }
    const key =
      propName in vitalNames
        ? (vitalNames[
            propName as keyof typeof vitalNames
          ] as keyof VitalsignPayload)
        : (propName as keyof VitalsignPayload)
    return this.vital ? this.vital[key] : '-'
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get relativeInfo() {
    return this.$store.getters['user/relativeInfo']
  }

  get isRelative() {
    return this.user.isPatientRelative
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  get patientId(): number | null | undefined {
    return this.user.isPatientRelative
      ? this.relativeInfo?.patient.id
      : this.user.id
  }

  get receivedValues() {
    return this.$store.getters['ble/receivedValues']
  }

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  get enabledAutoSending() {
    return this.$store.getters['ble/autoSending']
  }

  created() {
    if (this.isRelative) {
      this.getVitalsign()
      this.startTimer()
    }
  }

  startTimer() {
    this.timerId = setInterval(() => {
      this.getVitalsign()
    }, VITAL_DELAY * 1000)
  }

  stopTimer() {
    if (this.timerId) {
      window.clearInterval(this.timerId)
    }
  }

  beforeDestroy() {
    this.stopTimer()
  }

  createPayload() {
    const data = {
      heartRate: this.receivedValues.heartRate,
      pulseRate: this.receivedValues.pulseRate,
      temperature: this.receivedValues.temperature,
      weight: this.receivedValues.weight,
      spo2: this.receivedValues.spo2,
      glucose: this.receivedValues.glucose,
      sbp: this.receivedValues.systolicPressure,
      dbp: this.receivedValues.diastolicPressure
    }

    return (Object.keys(data) as Array<keyof VitalsignPayload>).reduce(
      (payload, key) => {
        if ((data as VitalsignPayload)[key] === null) {
          return payload
        }

        return Object.assign(payload, {
          [key]: (data as VitalsignPayload)[key]
        })
      },
      {} as VitalsignPayload
    )
  }

  async getVitalsign() {
    const patientId = this.patientId
    if (patientId == null) return
    const res = await this.$api.vitalsign.fetch({
      patientId
    })
    const vitals = res
    this.vital = res[0]
  }

  hanldeSend() {
    if (this.enabledAutoSending || this.user.isPatientRelative) {
      this.noticeMessage = 'このボタンは無効です。'
      this.showNoticeModal = true
      return
    }

    if (this.pending) {
      return
    }

    try {
      this.pending = true

      const payload = this.createPayload()

      if (Object.keys(payload).length === 0) {
        return
      }

      payload.measureDatetime = dayjs().format('YYYY-MM-DDTHH:mm:ssZ')

      this.$api.vitalsign.create({
        patientId: this.loginUser.id,
        payload
      })

      this.$store.commit('ble/clearReceivedValues')

      this.noticeMessage = '送信しました。'
      this.showNoticeModal = true
    } catch (error) {
      console.error(error)
    } finally {
      this.pending = false
    }
  }

  handleCloseNotice() {
    this.showNoticeModal = false
  }

  getStatusColor(value: number) {
    if (value && value >= 601) return 'red'
    if (value && value <= 19) return 'blue'
    return ''
  }
}
